$(function() {
    
    "use strict";
    
    //===== Prealoder
    
    $(window).on('load', function(event) {
        $('#preloader').delay(500).fadeOut(500);
    });
    
    
    //===== Mobile Menu 
    
    $(".navbar-toggler").on('click', function() {
        $(this).toggleClass('active');
    });
    
    $(".navbar-nav a").on('click', function() {
        $(".navbar-toggler").removeClass('active');
    });
    
    
    //===== close navbar-collapse when a  clicked
    
    $(".navbar-nav a").on('click', function () {
        $(".navbar-collapse").removeClass("show");
    });
    
    
    //===== Sticky
    
    $(window).on('scroll',function(event) {    
        var scroll = $(window).scrollTop();
        if (scroll < 10) {
            $(".navgition").removeClass("sticky");
        }else{
            $(".navgition").addClass("sticky");
        }
    });
    
    
    //===== Section Menu Active
    
    var scrollLink = $('.page-scroll');
        // Active link switching
        $(window).scroll(function() {
        var scrollbarLocation = $(this).scrollTop();

        scrollLink.each(function() {

          var sectionOffset = $(this.hash).offset().top - 90;

          if ( sectionOffset <= scrollbarLocation ) {
            $(this).parent().addClass('active');
            $(this).parent().siblings().removeClass('active');
          }
        });
    });
    
    
    //====== Magnific Popup
    
    $('.video-popup').magnificPopup({
        type: 'iframe'
        // other options
    });
    
    
    //===== Back to top
    
    // Show or hide the sticky footer button
    $(window).on('scroll', function(event) {
        if($(this).scrollTop() > 600){
            $('.back-to-top').fadeIn(200)
        } else{
            $('.back-to-top').fadeOut(200)
        }
    });
    
    
    //Animate the scroll to yop
    $('.back-to-top').on('click', function(event) {
        event.preventDefault();
        
        $('html, body').animate({
            scrollTop: 0,
        }, 1500);
    });
    
    
    //===== 
    



  });

$(document).ready(function() {
  
	$(".our-training-storie-block").each(function () {
		$(this).on("mouseover", function (e) {
			$(this).addClass("active");
			$(this).find('.training-image video')[0].play();
		});
		$(this).on("mouseout", function (e) {
			$(this).removeClass("active");
			$(this).find('.training-image video')[0].pause();
		});
	});
});




    
    $(document).ready(function() {
  
   $('.read-more').click(function() {

  $(this).siblings('.short-description').toggleClass('hidden');
  $(this).siblings('.full-description').toggleClass('hidden');
  if ($(this).text() === 'קרא עוד') {
    $(this).text('קרא פחות');
  } else {
    $(this).text('קרא עוד');
  }
});
  });
    
    
    
    
    $(document).ready(function() {
  $(window).scroll(function() {
    var scrollPos = $(window).scrollTop();
    
    $('#tag_filter a').each(function() {
      var hash = this.hash;
      var target = $(hash);
      var targetPos = target.offset().top - 150; // Adjust the 50px according to your need
      
      if (scrollPos >= targetPos && scrollPos < targetPos + target.outerHeight()) {
        $(this).addClass('hover');
      } else {
        $(this).removeClass('hover');
      }
    });
  });
});

    
    
    
    
 